// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TCreateProjectRuleRequestPayload,
  TCreateProjectRuleResponsePayload,
  TDeleteProjectRuleRequestPayload,
  TDeleteProjectRuleResponsePayload,
  TGetProjectPromptRequestPayload,
  TGetProjectPromptResponsePayload,
  TGetProjectRulesRequestPayload,
  TGetProjectRulesResponsePayload,
  TUpdateProjectPromptRequestPayload,
  TUpdateProjectPromptResponsePayload,
  TUpdateProjectRuleRequestPayload,
  TUpdateProjectRuleResponsePayload,
} from './prompts.types.ts';

export const createPromptsApi = (transport: TApiTransport) => ({
  /** Creates a project rule */
  createProjectRule: (
    payload: TCreateProjectRuleRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TCreateProjectRuleRequestPayload,
      TCreateProjectRuleResponsePayload
    >('/create_project_rule', payload, options),

  /** Deletes a project rule */
  deleteProjectRule: (
    payload: TDeleteProjectRuleRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TDeleteProjectRuleRequestPayload,
      TDeleteProjectRuleResponsePayload
    >('/delete_project_rule', payload, options),

  /** Returns the project's prompt */
  getProjectPrompt: (
    payload: TGetProjectPromptRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetProjectPromptRequestPayload,
      TGetProjectPromptResponsePayload
    >('/get_project_prompt', payload, options),

  /** Lists project rules */
  getProjectRules: (
    payload: TGetProjectRulesRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetProjectRulesRequestPayload,
      TGetProjectRulesResponsePayload
    >('/get_project_rules', payload, options),

  /** Updates the project's prompt */
  updateProjectPrompt: (
    payload: TUpdateProjectPromptRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TUpdateProjectPromptRequestPayload,
      TUpdateProjectPromptResponsePayload
    >('/update_project_prompt', payload, options),

  /** Updates a project rule */
  updateProjectRule: (
    payload: TUpdateProjectRuleRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TUpdateProjectRuleRequestPayload,
      TUpdateProjectRuleResponsePayload
    >('/update_project_rule', payload, options),
});
